import axiosInstance from 'api/axios';
import { APIResponse } from '../types';

export interface CollaboratorResponse {
  id: number;
  collaborator_user_id?: string;
  collaborator_user_username?: string;
  collaborator_user_email?: string;
  blog_id: number;
  status: string;
}

export interface UserResponse {
  user_id: string;
  username: string;
  email: string | null;
  img_url: string | null;
  role: 'admin' | 'user';
  created_at: string;
}

export const collabService = {
  addCollaborator: async (
    blogId: string,
    username: string
  ): Promise<APIResponse<CollaboratorResponse>> => {
    const response = await axiosInstance.private.post(
      `/api/v1/blogs/${blogId}/collaborators/`,
      {
        collaborator_user_username: username,
        permission_level: 1
      }
    );
    return response.data;
  },

  inviteCollaborator: async (
    blogId: string,
    email: string
  ): Promise<APIResponse<void>> => {
    const response = await axiosInstance.private.post(
      `/api/v1/blogs/${blogId}/invite/collaborators/`,
      {
        collaborator_user_email: email,
      },
    );
    return response.data;
  },

  getCollaborators: async (
    blogId: string
  ): Promise<APIResponse<CollaboratorResponse[]>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/blogs/${blogId}/collaborators/`,
    );
    return response.data;
  },

  removeCollaborator: async (
    blogId: string,
    collaboratorId: number
  ): Promise<APIResponse<void>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/blogs/${blogId}/collaborators/${collaboratorId}`
    );
    return response.data;
  },

  searchUsers: async (query: string): Promise<APIResponse<UserResponse[]>> => {
    const response = await axiosInstance.private.get(`/api/v1/auth/users/search`, {
      params: { query },
    });
    return response.data;
  },

  syncAccess: async (): Promise<APIResponse<{ shared_blogs_id: string[] }>> => {
    const response = await axiosInstance.private.put(
      '/api/v1/blogs/sync/access',
      null,
    );
    return response.data;
  },
};
